import { UIFlightData, UIPriceBreakdown, UIProductFlexibleTicket } from "@flights/types";
import { pricingUtils } from "@flights/web-api-utils-universal";

export const getFlexibleTicketTotalPriceFromFlight = (flight: UIFlightData) => {
  const flexibleTicket = flight.ancillaries?.flexibleTicket;

  if (!flexibleTicket) throw Error("Missing flexible ticket data");

  return getFlexibleTicketTotalPrice(flight, flexibleTicket);
};

export const getFlexibleTicketTotalPrice = (flight: UIFlightData, flexibleTicket: UIProductFlexibleTicket) => {
  return pricingUtils.sumPriceBreakdown([flight.priceBreakdown, getFlexibleTicketTotalUpgradePrice(flexibleTicket)]);
};

export const getFlexibleTicketTotalUpgradePrice = (flexibleTicket: UIProductFlexibleTicket): UIPriceBreakdown =>
  pricingUtils.sumPriceBreakdown(flexibleTicket.travellers.map(() => flexibleTicket.priceBreakdown));

export const getCfarTicketTotalPriceFromFlight = (flight: UIFlightData): UIPriceBreakdown | undefined => {
  const cfar = flight.ancillaries?.cancelForAnyReason;

  if (!cfar) return;

  return pricingUtils.sumPriceBreakdown([flight.priceBreakdown, cfar.priceBreakdown]);
};
